import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Col from "react-bootstrap/Col";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "./IssueListPage.css";
import IssueListContainer from "../../components/IssueListContainer/IssueListContainer";
import { loadATitleRequestAction } from "../../redux/actions/appTitles";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Badge from "react-bootstrap/Badge";

class IssueListPage extends React.Component {
  componentDidMount() {
    const { match, history } = this.props;

    if (this.props.titleName == null) {
      this.props.loadATitleRequestAction(match.params.titleID, toast, history);
    }
  }

  render() {
    const { match, history, title } = this.props;
    const meLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/pdf_books`;
    const titleName = this.props.titleName != null ? this.props.titleName : "";
    const titleAutomate = title != null ? title.automate : 0;

    return (
      <Container>
        <Row>
          <Col>
            <Breadcrumb active="true" className="path_container">
              <Breadcrumb.Item href={process.env.REACT_APP_URL_ROOT}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item href={meLink}>
                {titleName}
                {titleAutomate >= 1 && (
                  <Badge
                    variant="warning"
                    className="title_list_item_auto_badge"
                  >
                    {titleAutomate >= 2 ? "Fit Reading" : "TOC"}
                  </Badge>
                )}
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Tabs
          activeKey={match.params.bookType}
          onSelect={key => history.replace(key)}
          transition={false}
        >
          <Tab eventKey="pdf_books" title="Home">
            <IssueListContainer
              bookType="pdf_books"
              titleID={match.params.titleID}
            />
          </Tab>
        </Tabs>
        <Row />
      </Container>
    );
  }
}

const mapState = (state, ownProps) => {
  const { appTitles } = state;
  const { match } = ownProps;

  const titleName =
    appTitles[match.params.titleID] == null
      ? null
      : appTitles[match.params.titleID].name;

  return {
    titleName: titleName,
    title: appTitles[match.params.titleID]
  };
};

const mapDispatch = {
  loadATitleRequestAction
};

export default connect(
  mapState,
  mapDispatch
)(withRouter(IssueListPage));
